














































































import {Component, Prop, Emit} from 'vue-property-decorator';
import Form, {Send} from '@/components/form-base';
import {DialogForm, FormOverlay} from '@/components/bwaff';
import ErrorAggregator from '@/components/errors/error-aggregator.vue';
import config from 'src/config';

import UiLogout from '@/components/ui/ui-logout.vue';
import { mixins } from 'vue-class-component';
import PaymentStatusMixin from '@/views/layout/navigation/mixins/payment-status-mixin';
import subscriptionApi, { SubscriptionApi } from '@/views/settings/subscription/api';

export interface UpdatePaymentMethodDialogOpenOptions {
  backCallback?: () => void; 
}

@Component({
  components: {
    FormOverlay,
    DialogForm,
    ErrorAggregator,
    UiLogout,
  }
})
export default class UpdatePaymentMethodDialog extends mixins(Form, PaymentStatusMixin) {
  @Prop({ default: {} })
  data: any;

  api: SubscriptionApi = subscriptionApi;
  edit: boolean = true;
  loading: boolean = false;
  promoCode: string = '';
  billingInfo: any = {billing_address:{}};
  mask: string = 'credit-card';
  cardNumberElement: any = null;
  cardExpiryElement: any = null;
  cardCvcElement: any = null;
  stripe: any = null;
  cardElements: any = null;

  errors: any[] = [];
  errorsControlActive: boolean = false;

  @Emit('success')
  onSuccess(time: string) {}

  rules: any = {
    counter: (value: any) => { return (value || []).length <= 3 || 'Max 3 characters'},
  };

  onStripeReady(){
    const $on = this.$on.bind(this);

    $on('error', (e: any, payload: any) => {
      this.$store.commit('loading', false);
      this.api.loading = false;

      this.errors = this.translateErrors(this.parseErrors(e.data.errors), e.data.message);
      this.errorsControlActive = true;
    });

    if ((window as any).Stripe === undefined) {
      return this.bus.emit('toast-error', this.t('Stripe library isn\'t loaded'));
    }

    this.stripe = (window as any).Stripe(config.stripeToken, {
      locale: this.$i18n.locale
    });
    const style = {
      'base': {
        fontSize: '12px',
        color: this.$colors.graphite,
        lineHeight: '32px',
        fontFamily: 'Lato, Helvetica, sans-serif, -apple-system',
        letterSpacing:'0.6px',
      },
      invalid: {
        color: this.$colors.graphite,
        borderColor: this.$colors.red
      },
    }
    this.cardElements = this.stripe.elements()
    this.cardNumberElement = this.cardElements.create('cardNumber', {style: style}  );
    this.cardNumberElement.mount(this.$refs.cardNumber);
    this.cardExpiryElement = this.cardElements.create('cardExpiry', {style: style});
    this.cardExpiryElement.mount(this.$refs.cardExpiry);
    this.cardCvcElement = this.cardElements.create('cardCvc', {style: style});
    this.cardCvcElement.mount(this.$refs.cardCvc);

    this.$store.commit('loading', false);
  }

  mounted() { 
    if((window as any).Stripe){
      this.onStripeReady()
    }else{
      const stripeLibrary = document.createElement( 'script');
      stripeLibrary.src = 'https://js.stripe.com/v3/';
      document.head.appendChild(stripeLibrary);
      (stripeLibrary.onload as any) = this.onStripeReady
    } 
  }

  get backCallback() {
    const { backCallback } = this.data

    if (this.data.backCallback) {
      return () => {
        this.close()
        backCallback()
      }
    }
  }

  close() {
    this.$store.commit('loading', false);
    this.$emit('close');
  }

  @Send()
  async submit() {
    this.$store.commit('loading', true);
    const createPaymentMethod = await this.stripe.createPaymentMethod('card', this.cardNumberElement)

    if (createPaymentMethod.error) return this.submitErrorHandler(createPaymentMethod.error.message);

    const setupIntent = await this.api.billingApi
      .setupIntent({
        paymentMethodId:createPaymentMethod.paymentMethod.id
      })


    if(setupIntent.status==='requires_action' || setupIntent.status==='requires_source_action'){
      const confirmCardSetup = await this.stripe.confirmCardSetup(setupIntent.client_secret)
      if (confirmCardSetup.error) return this.submitErrorHandler(confirmCardSetup.error.message);
      return this.submitSuccess(confirmCardSetup.setupIntent.id)
    }

    if(setupIntent.status==='requires_payment_method' || setupIntent.status==='requires_source')
      return this.submitErrorHandler(this.t('Your card was denied, please provide a new payment method'));

    if(setupIntent.status==='succeeded') return this.submitSuccess(setupIntent.id)
  };


  submitErrorHandler(error:string){
    this.$store.commit('loading', false);
    this.state.loading = false;
    this.errors = [this.t('Validation failed'),error]
    this.errorsControlActive = true;
  }

  async submitSuccess(token:string){
    return await this.api.postUpdateCard({
      'token': token,
      'gateway': 'stripe3ds'
    }, true).then(() => {
      return this.api.getCustomer().then(() => {
        this.bus.emit('toast-success', this.t('Payment method successfully changed.'));
        this.close()
      })
    })
  }
}
